import { render } from "./NewPromotionHeader.vue?vue&type=template&id=70b62168&scoped=true"
import script from "./NewPromotionHeader.vue?vue&type=script&lang=js"
export * from "./NewPromotionHeader.vue?vue&type=script&lang=js"

import "./NewPromotionHeader.vue?vue&type=style&index=0&id=70b62168&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b62168"]])

export default __exports__